module.exports = __webpack_public_path__ + "media/images/android-chrome-72x72-5bf90b12fe825513f1bafbdbc5598e3c.png";